export const LAST_UPDATED_DATE = '24 March 2026';

export const LEGAL_TODOS = {
  operatorName: '101Setups (project name; operator legal entity not yet formally registered)',
  postalAddress: 'No postal address is currently available for legal notices.',
  taxId: 'No NIF / VAT / tax ID is currently available.',
  legalContactEmail: 'info@101setups.com',
  jurisdictionCity: 'Madrid',
};
